module.exports = __webpack_public_path__ + "img/Path 21@3x.e1f22cde.png";